
































































































































































    
export default {
    name: "app",
    data() {
        return {    
            initReg: true,
            showRegistration: false,
            designSteps: [],
            reportImgSrc: 1,
            showReportGeneratorDiv: false,        
            steps: [
                {
                    target: '#tourContainer',                        
                    content: `<p class="brand-tour-label">Welcome to <br><span class="brandSpan-tour">timber<b>X</b></span></p>Use this tool at project concept stage to understand the merits of mass timber in structural material selection. `,
                    params: {
                        highlight: false
                    }
                },
                {
                    target: '#tourContainer',
                    content: `<br><p><b>This is a concept design tool.</b> It is intended to guide those involved in the early stages of a project through material selection by providing high level comparative insights of timber, concrete and structural steel systems.</p><p><b>This is not a detailed design tool.</b> Buildings are complex and their successful design depends on several technical, market, and user implications that impact geometry, schedule, and price.  Since the tool represents only a simplified and isolated frame, the outcomes of the tool should not be taken as absolute, but rather an informed starting point for concept development.</p>`,
                    params: {
                        highlight: false
                    }
                },
                {
                    target: '#tourContainer',
                    content: '<br><p>The tool allows the user to define the building use and the size of standard structural bay of a typical floor.</p>' +
                        '<p>The tool then summarizes 4 primary outcomes:</p><ul class="tour-list"><li>The weight of the system</li><li>The overall structural depth of the system</li><li>The approximate cost of the structural floor system only</li><li>The approximate embodied carbon of the structure</li><br><p>Click the info menu icon right of each timberX card to read the detailed assumptions.</p>',
                    params: {
                        highlight: false
                    }
                },                    
                {
                    target: '.v-step-6',
                    content: '<br><p>The cards on the left show the results of the four primary outcomes.</p>' +
                        '<p>The crown symbol <i class="v-icon notranslate mdi mdi-crown gold-crown"></i> indicates which of the 3 options displayed on the cards performs the best for the given metric, while the 2 and 3 superscripts represent 2nd and 3rd in the ranking.</p><p>Click the info menu icon at the top roght of each card to read the detailed material specific assumptions. </p>',
                    params: {
                        placement: 'right'
                    }
                },                                       
                {
                    target: '.v-step-8',
                    content: 'The interactive 3D model on the bottom of the cards gives a simplified view of the system.  The model can be rotated and expanded using the icons in the bottom right corner.',
                    params: {
                        placement: 'right'                            
                    }
                },
                {
                    target: '.v-step-9',
                    content: 'On the top right, view a comparison of the 3 selected systems in the radar chart, displaying the trade-offs in bay weight, structural depth, approximate structural system cost, and approximate embodied carbon.  The closer to the centre of the radar chart, the better the solution.',
                    params: {
                        placement: 'left'
                    }
                },
                {
                    target: '.v-step-10',
                    content: 'On the bottom right, a table is provided to see how all systems compare.  The systems are described in the info menu icon at the top right of timberX.  Note that by clicking one of the timber options in this table the timber card will update.',
                    params: {
                        placement: 'left'
                    }
                },
                {
                    target: '.v-step-11',
                    content: '<p>Once you are finished selecting the inputs, click the generate report button.  This report will expand on the benefits, costs, and challenges of mass timber.  Click this button to launch the Report Generator window.</p>',
                    params: {
                        placement: 'bottom',
                        highlight: true
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.showReportGeneratorDiv = false;
                        resolve(true)
                    })
                },
                {
                    target: '.v-step-12',
                    content: '<br><p>The Report Generator Window has two tabs the user can navigate.</p><p>1.  System Selection</p><p>This window will automatically open to the System Selection tab.  Select from the table which timber systems you would like included in the report.  You may choose a minimum of one system, and a maximum of seven.</p>',
                    params: {
                        placement: 'left',
                        highlight: true
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.showReportGeneratorDiv = true;
                        this.reportImgSrc = 1;
                        resolve(true)
                    })
                },
                 {
                     target: '.v-step-12',
                     content: '<br><p>2. Report Topics</p><p>Select from the list which topics you would like included in the report.  The report will be customized based on your selection.  You must select at least one topic to generate a report.</p>',
                     params: {
                         placement: 'left',
                         highlight: true
                     },
                     before: type => new Promise((resolve, reject) => {
                         this.showReportGeneratorDiv = true;
                         this.reportImgSrc = 2;
                         resolve(true)
                     })
                 },
                 {
                    target: '.v-step-12',
                    content: '<br><p>The report preview window will appear.  If you are satisfied with the report, click download.  If you would like to make changes, click "x" in the top right corner and you will be brought back to the Report Generator window.</p>',
                    params: {
                        placement: 'left',
                        highlight: true
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.showReportGeneratorDiv = true;
                        this.reportImgSrc = 3;
                        resolve(true)
                    })
                },
                {
                    target: '.v-step-16',
                    content: '<p>For more information on the general assumptions built into the tool, and to launch this tour again, click the General Info Menu here.</p>',
                    params: {
                        placement: 'bottom'
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.showReportGeneratorDiv = false;
                        resolve(true)
                    })
                }
            ],
            stepsDesign: [
                {
                    target: '.v-step-5',
                    content: '<br>On the top bar, select your sector (the building use).  Click the info menu icon at the top right of timberX to read more about sectors included.',
                    params: {
                        placement: 'bottom'
                    }
                },
                {
                    target: '.v-step-4',
                    content: '<br>A common typical grid size for the sector you selected will be shown.  You may modify the dimensions using the slider, or leave the default.'
                },                           
                {
                    target: '.v-step-17',
                    content: 'Click the Light Bulb icon to learn if there is a bay size that will result in a more cost efficient timber system.',
                    params: {
                        placement: 'bottom'
                    }
                },
                {
                    target: '.v-step-7',
                    content: 'Within the timber card, manually choose from up to 7 different timber systems.  The systems are more thoroughly described in the Info. <br><br> Click the Auto-Select box to display the timber solution with optimal performance.',
                    params: {
                        placement: 'right'
                    }
                }       
                
            ],
            systemCostSteps: [{
                target: '.v-step-systemcost',                   
                params: {
                    placement: 'bottom'
                }                    
            }],
            showInfoMsg: false,
            infoMessageTitle: 'A verification link has been sent to your email account',
            infoMessage: ""                
        }
    },
    components: {            
        SubHeader: () => import('./SubHeader.component.vue'),
        MainContent: () => import('./MainContent.component.vue'),
        Registration: () => import('./Registration.component.vue'),
        InfoMessage: () => import("./InfoMessage.vue")
    },
    created() {            
    },     
    async beforeDestroy() {
        clearInterval(this.reportFlashTimer);            
    },
    computed: {
        reportGenImg() {
            return (this.reportImgSrc === 3 ? require('@/assets/imgReportGen3.png') : this.reportImgSrc === 2 ? require('@/assets/imgReportGen2.png') : require('@/assets/imgReportGen.png'));
        },
        floorSystemCost() {
            return require('@/assets/floorSystemCost.jpg');
        },
        ideaIcon() {
            return require('@/assets/idea.png');
        }
    },
    async mounted() {            
        await this.$store.dispatch("misc/user_IP");
        await this.checkRegistration();                          
    },
    methods: {                                  
        onSkipTour() {
            this.showReportGeneratorDiv = false;
            this.$tours["timberTour"].skip();
            this.startEndSystemCostTour();
        },
        onFinishTourDesign() {
            this.$tours["timberTourDesign"].finish();
            this.startEndSystemCostTour();
            
        },
        onFinishSystemCost() {
            this.startEndSystemCostTour(false);
        },
        onSkipTourDesign() {
            this.$tours["timberTourDesign"].skip();
            this.startEndSystemCostTour();               
        },
        startEndSystemCostTour(start = true) {
            if (start) {
                this.$tours["systemCostTour"].start();
                this.$root.$emit("onSystemCostTour", true);
            } else {
                this.$tours["systemCostTour"].finish();
                this.$root.$emit("onSystemCostTour", false);

                this.initTimers(); 
            }
        },
        onStartDesigning() {
            this.showReportGeneratorDiv = false;
            this.$tours["timberTour"].skip();
            this.$tours["timberTourDesign"].start();    
        },      
        initTimers() {                                
            if (this.initReg) {
                this.initRegistration();
            } else {
                this.$root.$emit("initInactivityTimer");
                this.$root.$emit("onInitReportBtnFlash");
            }
        },                                    
        async checkRegistration() {
            var reg = await this.$store.getters["misc/getRegistrationStore"];
            if (reg) {
                this.initReg = false;
                return;
            }    
            if (this.$store.state.misc.userIP) {
                var user = await this.$store.dispatch("datafields/getUser", [this.$store.state.misc.userIP, '1']);
                if (user && user.data && user.data.length > 0) {
                    this.$store.dispatch("misc/setRegistrationStore", { val: "1" });
                    this.initReg = false;
                    return;
                }                    
            }
        },
        initRegistration() {
            var _t = this;
            setTimeout(function () {           
                _t.showRegistration = true;     
            }, 20000);                
        },               
        showRegistrationMessage() {                
            this.showInfoMsg = true;
            this.infoMessage = 'Please click on the link that has just been sent to your email account to verify your email and continue the registration process.';
        },
        onRegDone() {
            this.$root.$emit("onInitReportBtnFlash");
            this.$root.$emit("initInactivityTimer");
        }
        
    }
}
